// extracted by mini-css-extract-plugin
module.exports = {"card":"announcement-section_card__VhCDX"};